import PopupContent from '../PopupContent'
import * as RT from '../../config/routeType'

/**
 * Retorna el componente adecuado para el popup en función de la ruta y contenido.
 * @param {Object} params
 * @param {string} params.pathname - Ruta actual.
 * @param {Object} params.propsContent - Contenido a mostrar en el popup.
 * @param {[number, number]} params.lngLat - Coordenadas del popup (opcional).
 * @returns {JSX.Element|null}
 */
export const getPopupComponent = ({ pathname, propsContent, lngLat }) => {
  const propsUpdate = {
    ...propsContent,
    showDescriptionBotton:
      pathname.includes(RT.REGISTER_TREE) || pathname.includes(RT.MANAGEMENT_TREE),
    pathname,
  }

  const isValidObject =
    propsContent &&
    typeof propsContent === 'object' &&
    Object.keys(propsContent).length > 0

  if (!isValidObject) {
    return null
  }

  return <PopupContent {...propsUpdate} />
}
